export default __webpack_public_path__ + "static/media/portfolio-2.95e18234.jpg";